import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { CookieConsentProvider } from "@/contexts/CookieConsentContext";
import { CookieConsentBanner } from "@/components/CookieConsentBanner";
import { CookiePreferencesModal } from "@/components/CookiePreferencesModal";
import { CookiePreferencesButton } from "@/components/CookiePreferencesButton";
import AboutContatti from "./pages/AboutContatti";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TerminiCondizioni from "./pages/TerminiCondizioni";
import NotFound from "./pages/NotFound";
import OAuthConsent from "./pages/OAuthConsent";

// V2 — isolated funnel (see docs/). Do NOT import from src/pages or src/components (except ui/).
import V2Landing from "./v2/pages/Landing";
import V2RealityCheck from "./v2/pages/RealityCheck";
import V2RealityCheckResult from "./v2/pages/RealityCheckResult";
import V2Pricing from "./v2/pages/Pricing";
import V2CheckoutSuccess from "./v2/pages/CheckoutSuccess";
import V2Sprint from "./v2/pages/Sprint";
import V2Account from "./v2/pages/Account";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <CookieConsentProvider>
        <AuthProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<V2Landing />} />
                <Route path="/about" element={<AboutContatti />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/termini-e-condizioni" element={<TerminiCondizioni />} />
                <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
                <Route path="/profilo" element={<Navigate to="/v2/sprint" replace />} />

                {/* V2 funnel — mock UI only, isolated from legacy code */}
                <Route path="/v2" element={<V2Landing />} />
                <Route path="/v2/reality-check" element={<V2RealityCheck />} />
                <Route path="/v2/reality-check/result" element={<V2RealityCheckResult />} />
                <Route path="/v2/pricing" element={<V2Pricing />} />
                <Route path="/v2/checkout/success" element={<V2CheckoutSuccess />} />
                <Route path="/v2/sprint" element={<V2Sprint />} />
                <Route path="/v2/account" element={<V2Account />} />

                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
              <CookieConsentBanner />
              <CookiePreferencesModal />
              <CookiePreferencesButton />
            </BrowserRouter>
          </TooltipProvider>
        </AuthProvider>
      </CookieConsentProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
